import { ICuffaUpdateLandCategoryDto } from 'interfaces/cuffa.interface';
import { CuffaLandCategoryEnum } from 'interfaces/cuffa.interface';

export const buildLandCategoryPayload = (values: any): ICuffaUpdateLandCategoryDto => {
  const payload: ICuffaUpdateLandCategoryDto = {
    land_category: values.landCategory,
  };

  let additionalInfo = '';
  switch (values.landCategory) {
    case CuffaLandCategoryEnum.ASSENTAMENTO_FEDERAL_ESTADUAL:
      additionalInfo = values.codigoAssentamento;
      break;
    case CuffaLandCategoryEnum.PNCF_TERRA_BRASIL_BANCO_DA_TERRA:
      additionalInfo = values.nomePncFTerraBrasilBancoDaTerra;
      break;
    case CuffaLandCategoryEnum.COMUNIDADE_QUILOMBOLA:
      additionalInfo = values.nomeComunidadeQuilombola;
      break;
    case CuffaLandCategoryEnum.COMUNIDADE_TRADICIONAL:
      additionalInfo = values.nomeComunidadeTradicional;
      break;
    case CuffaLandCategoryEnum.TERRA_INDIGENA:
      additionalInfo = values.nomeTerraIndigena;
      break;
    default:
      break;
  }

  if (additionalInfo) payload.land_category_additional_info = additionalInfo;
  return payload;
};

export const parseSavedLandCategory = (data: any) => {
  if (!data) return {
    landCategory: '',
    codigoAssentamento: '',
    nomePncFTerraBrasilBancoDaTerra: '',
    nomeComunidadeQuilombola: '',
    nomeComunidadeTradicional: '',
    nomeTerraIndigena: '',
  };

  const formData = {
    landCategory: data.land_category || '',
    codigoAssentamento: data.land_category === CuffaLandCategoryEnum.ASSENTAMENTO_FEDERAL_ESTADUAL
      ? data.land_category_additional_info || ''
      : '',
    nomePncFTerraBrasilBancoDaTerra: data.land_category === CuffaLandCategoryEnum.PNCF_TERRA_BRASIL_BANCO_DA_TERRA
      ? data.land_category_additional_info || ''
      : '',
    nomeComunidadeQuilombola: data.land_category === CuffaLandCategoryEnum.COMUNIDADE_QUILOMBOLA
      ? data.land_category_additional_info || ''
      : '',
    nomeComunidadeTradicional: data.land_category === CuffaLandCategoryEnum.COMUNIDADE_TRADICIONAL
      ? data.land_category_additional_info || ''
      : '',
    nomeTerraIndigena: data.land_category === CuffaLandCategoryEnum.TERRA_INDIGENA
      ? data.land_category_additional_info || ''
      : '',
  };

  return formData;
};
